import { render, staticRenderFns } from "./move_issue_button.vue?vue&type=template&id=f71528c0"
import script from "./move_issue_button.vue?vue&type=script&lang=js"
export * from "./move_issue_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports